import { useEffect, useState, useContext } from "react";
import PlanCard from "./PlanCard";
import planTypesData from "../data/planTypesData";
import axios from "axios";
import { UserContext } from "../context/UserContext";

function PlanSection() {
  // const [loading, setLoading] = useState(true);
  const [plans, setPlans] = useState([]);
  const { user } = useContext(UserContext);
  const [userSubscription, setUserSubscription] = useState({
    Rollover: false,
    Premium: false,
  });

  useEffect(() => {
    axios
      .get("plans")
      .then(({ data }) => {
        setPlans(data);
      })
      .catch((err) => {
        console.log(err.message);
        if (plans?.length < 1) {
          setPlans(planTypesData);
        }
      });

    if (user) {
      axios
        .get(`/auth/profile/${user?.id}`)
        .then(({ data }) => {
          if (data) {
            setUserSubscription(data.subscription);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [user, setUserSubscription, plans?.length]);

  const planElements = plans.map((plan) => (
    <PlanCard
      plan={plan}
      userSubscription={userSubscription}
      setUserSubscription={setUserSubscription}
      key={plan._id}
    />
  ));
  return (
    <section className="plans_section">
      <h2>Our Plans</h2>

      {plans.length < 1 ? (
        <div className="loading_container">
          <div className="loading_spinner"></div>
          <p>Loading Plans...</p>
        </div>
      ) : (
        <div className="plans_container">{planElements}</div>
      )}
    </section>
  );
}

export default PlanSection;
